// extracted by mini-css-extract-plugin
export default {"search":"index_search__09Xc3","searchTotal":"index_searchTotal__qkn6Q"};